import React from "react";
import { applyMiddleware } from 'redux';
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";

import { Drizzle, generateStore } from "./drizzle";
import { DrizzleProvider } from "./drizzle/drizzleContext";
import options from "./drizzle/drizzleOptions";
import { createLogger } from "redux-logger";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import allReducers from './reducers';
import allSagas from './sagas';

import App from "./App";
import LoadingContainer from './drizzle/LoadingContainer';

const appReducers = {
  ...allReducers
};

const appSagas = [
  ...allSagas
]

const logger = createLogger({
  diff: true,
  collapsed: true
});

const store = generateStore({
  drizzleOptions: options,
  appReducers: appReducers,
  appSagas: appSagas,
  // appMiddlewares: [ logger ]
});

const drizzle = new Drizzle(options, store);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <>
    <React.StrictMode>
      <ReduxProvider store={drizzle.store}>
        <DrizzleProvider drizzle={drizzle}>
          <LoadingContainer>
            <BrowserRouter>
              <Routes>
                <Route path='/*' element={<App />}/>
              </Routes>
            </BrowserRouter>
          </LoadingContainer>
        </DrizzleProvider>
      </ReduxProvider>
    </React.StrictMode>
  </>
);
